import type { MyEstimateGroup, MyEstimateResponse } from '@massilia/contracts'

import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../lib/client.js'
import { publicEstimateKeys } from './keys.js'
import { quoteAuthHeaders } from './quote-token.js'

export interface PublicQuote {
  request: Omit<MyEstimateGroup, 'responses'>
  response: MyEstimateResponse
}

export const useGetPublicQuoteQuery = (responseId: string, enabled = true) =>
  useQuery({
    enabled,
    queryFn: async () => {
      const response = await apiClient.client.get<PublicQuote>(
        `/public/estimate-responses/${responseId}`,
        { headers: quoteAuthHeaders(responseId) }
      )
      return response.data
    },
    queryKey: publicEstimateKeys.quote(responseId),
    retry: false,
  })
